import { supabase } from "@/integrations/supabase/client";

export interface MultiDocumentTailoringRequest {
  resumeText: string;
  jobDescription: string;
  selectedDocumentTypes: string[];
  jobTitle?: string;
  companyName?: string;
  sectionsToTailor?: string[];
  writingStyle?: string;
  quantificationLevel?: string;
  additionalInstructions?: string;
  selectedPrompts?: Record<string, string>; // document_type -> prompt_id
}

export interface MultiDocumentTailoringResponse {
  success: boolean;
  tailoredResumeContent?: string;
  coverLetterContent?: string;
  linkedinContent?: string;
  thankYouLetterContent?: string;
  outreachEmailContent?: string;
  executiveBioContent?: string;
  analysisData?: any;
  metadata?: {
    documentsGenerated: string[];
    totalDocuments: number;
    jobTitle: string;
    companyName: string;
  };
  error?: string;
}

export class MultiDocumentTailoringService {
  static async generateMultipleDocuments(
    request: MultiDocumentTailoringRequest
  ): Promise<MultiDocumentTailoringResponse> {
    try {
      console.log('Calling multi-document tailoring with:', {
        selectedDocumentTypes: request.selectedDocumentTypes,
        resumeLength: request.resumeText?.length || 0,
        jobDescriptionLength: request.jobDescription?.length || 0
      });

      const { data, error } = await supabase.functions.invoke('tailor-multi-documents', {
        body: request
      });

      if (error) {
        console.error('Multi-document tailoring error:', error);
        throw new Error(`Multi-document tailoring failed: ${error.message}`);
      }

      if (!data.success) {
        throw new Error(data.error || 'Multi-document tailoring failed');
      }

      console.log('Multi-document tailoring completed successfully:', {
        documentsGenerated: data.metadata?.documentsGenerated || [],
        totalDocuments: data.metadata?.totalDocuments || 0
      });

      return data as MultiDocumentTailoringResponse;

    } catch (error) {
      console.error('Error in MultiDocumentTailoringService:', error);
      throw new Error(
        error instanceof Error 
          ? error.message 
          : 'Failed to generate documents'
      );
    }
  }
}